module.exports = __webpack_public_path__ + "static/img/taxi_logo_lg.0d0bec64.png";